module.exports = __webpack_public_path__ + "img/mindMap.6527f1d0.png";